// notaExibida.js — A política de "que nota mostrar" do site inteiro, num arquivo só.
//
// O PEDIDO E O PROBLEMA:
// foi pedido que um livro sem nenhuma avaliação apareça com 5 estrelas.
// Cumprido — mas com uma ressalva que precisa ficar escrita, porque ela muda o
// que a estrela significa:
//
//   5 estrelas CHEIAS em 198 livros sem opinião nenhuma diz ao cliente que
//   todos são nota máxima. Quando as avaliações reais chegarem, quase todo
//   livro vai CAIR de nota (parecendo que piorou), e um livro com 5 estrelas
//   de verdade fica visualmente idêntico a um que ninguém avaliou.
//
// A saída adotada: as 5 estrelas aparecem, como pedido, mas em estado
// APAGADO (`atenuada = true`) quando não há avaliação — o mesmo desenho, sem
// afirmar uma nota que ninguém deu. Onde couber, o componente escreve
// "sem avaliações" ao lado.
//
// Se o dono decidir diferente depois (estrelas vazias, selo "Novo", nada), a
// mudança acontece AQUI e vale para catálogo, home, página do livro, quick
// view, compre junto e minha lista de uma vez.
//
// REGRA QUE NÃO MUDA: isto é EXIBIÇÃO. Nunca gravar 5 no banco — a média real
// ficaria contaminada para sempre.

/** Nota mostrada quando o livro ainda não tem nenhuma avaliação. */
export const NOTA_PADRAO = 5;

/** As 5 estrelas do padrão aparecem apagadas? (false = cheias, como qualquer nota) */
export const ATENUAR_SEM_AVALIACOES = true;

/**
 * Lê os campos que o backend manda junto com o livro
 * (`avaliacoes_avg_nota` e `avaliacoes_count`) e devolve tudo que um
 * componente precisa para desenhar as estrelas.
 *
 * Aceita o livro inteiro ou os dois números soltos, porque nem todo endpoint
 * usa o mesmo nome — `/ebook` devolve `avaliacoes_avg_nota`, o hook de
 * opiniões da página do livro já calcula `media`/`total` por conta própria.
 */
export function notaDoLivro(livro) {
  if (!livro) return notaExibida(0, 0);
  const media =
    livro.avaliacoes_avg_nota ?? livro.avaliacoes_media ?? livro.media ?? 0;
  const total = livro.avaliacoes_count ?? livro.avaliacoes_total ?? livro.total ?? 0;
  return notaExibida(media, total);
}

/**
 * @returns {{ nota: number, total: number, semAvaliacoes: boolean, atenuada: boolean, texto: string }}
 */
export function notaExibida(media, total) {
  const qtd = Math.max(0, Math.floor(Number(total) || 0));
  const semAvaliacoes = qtd === 0;
  const nota = semAvaliacoes ? NOTA_PADRAO : Number(media) || 0;

  return {
    nota,
    total: qtd,
    semAvaliacoes,
    atenuada: semAvaliacoes && ATENUAR_SEM_AVALIACOES,
    // "4,5 (12)" quando há nota; "sem avaliações" quando não há. O texto sai
    // daqui para não haver duas redações diferentes pelo site.
    texto: semAvaliacoes
      ? "sem avaliações"
      : `${nota.toFixed(1).replace(".", ",")} (${qtd})`,
  };
}

export default notaExibida;
